import React, { useState } from "react";
import "./LoginAdmin.css";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../components/Toast/ToastContainer";

const LoginAdmin = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!username || !password) {
            toast.error("Vui lòng nhập đầy đủ tài khoản và mật khẩu");
            return;
        }

        try {
            setLoading(true);

            const res = await fetch(
                "https://api.bvb.cybertech.com.vn/api/v1/auth/web-login",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ username, password }),
                }
            );

            if (!res.ok) {
                throw new Error("Sai tài khoản hoặc mật khẩu");
            }

            const data = await res.json();

            // ===== Save token =====
            localStorage.setItem("access_token", data.access_token);
            localStorage.setItem("role", data.role);
            localStorage.setItem("user_id", data.user_id);
            localStorage.setItem("username", username); // Lấy từ state username lúc nhập
            localStorage.setItem("full_name", data.full_name);
            console.log(data.access_token);
            navigate("/app/agents");
        } catch (err) {
            toast.error(err.message || "Đăng nhập thất bại");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h2>Đăng nhập Admin</h2>

                <form onSubmit={handleSubmit}>
                    <label>Tài khoản</label>
                    <input
                        type="text"
                        placeholder="Nhập tài khoản..."
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />

                    <label>Mật khẩu</label>
                    <input
                        type="password"
                        placeholder="Nhập mật khẩu..."
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <button type="submit" disabled={loading}>
                        {loading ? "Đang đăng nhập..." : "Đăng nhập"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginAdmin;
